import { IntlShape } from 'react-intl';
import { ModuleHierachy } from '../../common/module/types';
import { isPermitted } from 'src/app/common/utils';
import { LEAD_FORM_BASE_PATH, LEAD_FORM_ICON, LEAD_FORM_TITLE } from './constants';
import { customerCampaignModuleConfig } from '../Customer Campaign/module-def';
import { prospectReferralModuleConfig } from '../ProspectReferral/module-def';
import {
  AdminCustomerCampaignPermissionType,
} from '../Customer Campaign/constants';
import {
  AdminProspectReferralPermissionType,
} from '../ProspectReferral/constants';

export const leadFormModuleConfig = (permissions: string[], intl: IntlShape): ModuleHierachy => {
  const Translation = (id: string) => intl.formatMessage({ id });
  return {
    title: Translation(LEAD_FORM_TITLE),
    path: LEAD_FORM_BASE_PATH,
    icon: LEAD_FORM_ICON,
    enableRead: isPermitted(
      [
        AdminCustomerCampaignPermissionType.CUSTOMER_CAMPAIGN_READ,
        AdminCustomerCampaignPermissionType.CUSTOMER_CAMPAIGN_CREATE,
        AdminCustomerCampaignPermissionType.CUSTOMER_CAMPAIGN_UPDATE,
        AdminProspectReferralPermissionType.PROSPECT_REFERRAL_READ,
        AdminProspectReferralPermissionType.PROSPECT_REFERRAL_CREATE,
        AdminProspectReferralPermissionType.PROSPECT_REFERRAL_UPDATE,
      ],
      permissions,
    ),
    child: [
      customerCampaignModuleConfig(permissions, intl),
      prospectReferralModuleConfig(permissions, intl),
    ],
  };
};
